"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const colors_1 = require("@mui/material/colors");
const Puller = (0, material_1.styled)(material_1.Box)(() => ({
    width: 30,
    height: 6,
    backgroundColor: colors_1.grey[300],
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    left: 'calc(50% - 15px)',
}));
const Modal = ({ open, closeHandler, openHandler, noPadding, children, sx }) => {
    const theme = (0, material_1.useTheme)();
    const iOS = (0, react_1.useMemo)(() => typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent), []);
    const matches = (0, material_1.useMediaQuery)(theme.breakpoints.down('sm'));
    return matches ? ((0, jsx_runtime_1.jsxs)(material_1.SwipeableDrawer, { anchor: "bottom", open: open, onClose: closeHandler, onOpen: openHandler, disableBackdropTransition: !iOS, disableDiscovery: iOS, keepMounted: true, sx: sx, children: [(0, jsx_runtime_1.jsx)(Puller, {}), children] })) : ((0, jsx_runtime_1.jsx)(material_1.Dialog, { sx: sx, open: open, onClose: closeHandler, fullWidth: true, children: (0, jsx_runtime_1.jsx)(material_1.DialogContent, { sx: noPadding ? { padding: 0 } : undefined, children: children }) }));
};
exports.default = Modal;
